import { Scope } from '@atlassian/forge-consent';
import { defineMessages, FormattedMessage } from 'react-intl';
import type { FunctionComponent } from 'react';
import { scopeDefinitions } from '../../../../definitions/oidc';
import { useToken } from '../../../Flow/ConsentContextProvider';

const messages = defineMessages({
  scopeTitle: {
    id: 'scopeTitle',
    defaultMessage: 'This will allow {clientName} to:',
    description: 'Heading for oauth',
  },
});

const Scopes: FunctionComponent = () => {
  const { clientName, scopes } = useToken();

  return (
    <>
      <FormattedMessage
        {...messages.scopeTitle}
        values={{ clientName }}
        tagName="h3"
      />
      {scopes
        .map((s) => scopeDefinitions[s])
        .map((scope) => (
          <Scope
            id={scope.name}
            title={scope.name}
            key={scope.name}
            defaultIsExpanded
          >
            {scope.description}
          </Scope>
        ))}
    </>
  );
};

export default Scopes;
